import { Vue, newVue } from '@/config/vue'

On.VueInit({
  controller: 'home',
  init() {
    const HomeEventReporter = Vue.component('home-event-reporter', () =>
      import(/* webpackChunkName: "home-event-reporter" */ './HomeEventReporter.vue')
    )
    newVue({
      render: h => h(HomeEventReporter),
      mount: '.js-vue-home-event-reporter',
    })
  },
})
